import { createTranslator } from 'next-intl';
import { locale } from '@/i18n/locale';
import copies from '../../messages/en.json';

export const translate = createTranslator({
  locale: locale,
  messages: copies,
});
